
    <template>
        <h1>Status</h1>
        <v-form ref="form" style="text-align: left;">
            <div v-if="loadingData">Loading...</div>
            <v-container v-else density="compact" style="max-width: 1024px; text-align: left; float: left;">
                <div v-if="unregistered">
                    <span style="color: red;">
                        You are currently not registered, or not logged in. You will be unable to track any application submitted through this site unless you are
                        <router-link :to="{ name: 'register' }">registered</router-link> and <router-link :to="{ name: 'login' }">logged in</router-link>.
                    </span>
                </div>
                <div v-else-if="registered">
                    <span style="color: green;">
                        You are registered,
                    </span>
                    <span v-if="!hasNoApplication">
                        <span style="color: green;">and your application has been successfully submitted.<br /><br /></span>
                        <h3>
                            Application Status:
                            <span style="color: royalblue;" v-if="statusPending">PENDING</span>
                            <span style="color: orangered;" v-if="statusMoreInfo">MORE INFORMATION REQUIRED</span>
                            <span style="color: darkred;" v-if="statusDeclined">DECLINED</span>
                            <span style="color: green;" v-if="statusAccepted">ACCEPTED</span>
                        </h3>
                        <div v-html="!existingApp.applicationResultNote || existingApp.applicationResultNote.trim() === '' ? '' : '<b>Notes:</b> ' + existingApp.applicationResultNote + '<br /><br />'"></div>
                        Please review submitted information below:
                    </span>
                    <span v-if="hasNoApplication" style="color: green;">but your application has not yet been submitted.<br /><br /></span>
                </div>
                <div v-else>
                    <span>
                        Loading...
                    </span>
                </div>
                <v-card v-if="!hasNoApplication" style="text-align: left; margin-top: 15px; float: left; padding: 10px;">
                    <v-row>
                        <v-col>
                            <b>Application Date:</b> {{ new Date(existingApp.applicationDate).toLocaleDateString('en-US') }}
                        </v-col>
                        <v-col>
                            <b>Program Applied For:</b> {{ existingApp.waiverProgramName}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <b>First Name:</b> {{ person.firstName }}
                        </v-col>
                        <v-col>
                            <b>Middle Name:</b> {{ person.middleName }}
                        </v-col>
                        <v-col>
                            <b>Last Name:</b> {{ person.lastName }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <b>Preferred Name: </b> {{ person.preferredName }}
                        </v-col>
                        <v-col>
                            <b>Suffix:</b> {{ person.suffixName }}
                        </v-col>
                        <v-col>
                            <b>Birth Date:</b> {{ new Date(person.dateOfBirth).toLocaleDateString('en-US')}}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <b>SSN:</b> {{ person.ssn }}
                        </v-col>
                        <v-col>
                            <b>Gender: </b> {{ person.genderName }}
                        </v-col>
                        <v-col>
                            <b>Ethnicity: </b> {{ person.ethnicityName }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <b>Medicaid ID:</b> {{ person.medicaidId }}
                        </v-col>
                        <v-col>
                            <b>Are you, your spouse or parent a veteran or an active-duty member of the U.S. Military?</b> {{ existingApp.isActiveMilitary ? 'Yes' : 'No' }}
                        </v-col>
                        <v-col>
                            <b>County: </b> {{ existingApp.countyName }}
                        </v-col>
                    </v-row>
                    <v-card variant="outlined" title="Contact Info" class="text-left" style="margin-bottom: 10px; padding: 10px;">
                        <v-row>
                            <v-col>
                                <b>Phone Type:</b> {{ personPhone.phoneTypeName }}
                            </v-col>
                            <v-col>
                                <b>Phone Number:</b> {{ personPhone.phoneNumber }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <b>Email Type:</b> {{ personEmail.emailTypeName }}
                            </v-col>
                            <v-col>
                                <b>Email Address:</b> {{ personEmail.emailAddress }}
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card v-for="(personAddress, index) in personAddresses" :key="index" variant="outlined" :title="personAddress.addressTypeName + ' Address'" class="text-left" style="margin-bottom: 10px; padding: 10px;">
                        <v-row>
                            <v-col>
                                <b>Line 1:</b> {{ personAddress.addressLine1 }}
                            </v-col>
                        </v-row>
                        <v-row v-if="personAddress.addressLine2">
                            <v-col>
                                <b>Line 2:</b> {{ personAddress.addressLine2 }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <b>City:</b> {{ personAddress.city }}
                            </v-col>
                            <v-col>
                                <b>State:</b> {{ personAddress.stateName }}
                            </v-col>
                            <v-col>
                                <b>Zip:</b> {{ personAddress.zipCode }}
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-row>
                        <v-col>
                            <b>Preferred Method of Contact:</b> {{ person.preferredMethodOfContactName }}
                        </v-col>
                        <v-col>
                            <b>Are you applying for the Acquired Brain Injury Waiver?</b> {{ existingApp.isApplyingForAbi ? 'Yes' : 'No' }}
                        </v-col>
                    </v-row>
                    <p>&nbsp;</p>
                    <v-card variant="outlined" title="Emergency Contact" class="text-left" style="margin-bottom: 10px; padding: 10px;">
                        <v-row>
                            <v-col>
                                <b>Name:</b> {{ personEmergencyContact.personName }}
                            </v-col>
                            <v-col>
                                <b>Contact Type:</b> {{ personEmergencyContact.contactTypeName }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <b>Phone Type:</b> {{ personEmergencyContact.phoneTypeName }}
                            </v-col>
                            <v-col>
                                <b>Phone Number:</b> {{ personEmergencyContact.phoneNumber }}
                            </v-col>
                        </v-row>
                        <v-row v-if="personEmergencyContact.emailAddress">
                            <v-col>
                                <b>Email Type:</b> {{ personEmergencyContact.emailTypeName }}
                            </v-col>
                            <v-col>
                                <b>Email Address:</b> {{ personEmergencyContact.emailAddress }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <b>Address Type:</b> {{ personEmergencyContact.addressTypeName }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <b>Line 1:</b> {{ personEmergencyContact.addressLine1 }}
                            </v-col>
                        </v-row>
                        <v-row v-if="personEmergencyContact.addressLine2">
                            <v-col>
                                <b>Line 2:</b> {{ personEmergencyContact.addressLine2 }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <b>City:</b> {{ personEmergencyContact.city }}
                            </v-col>
                            <v-col>
                                <b>State:</b> {{ personEmergencyContact.stateName }}
                            </v-col>
                            <v-col>
                                <b>Zip:</b> {{ personEmergencyContact.zipCode }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <b>Preferred Method of Contact:</b> {{ personEmergencyContact.preferredMethodOfContactName }}
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card variant="outlined" title="Case Management Agency Selection" class="text-left" style="margin-bottom: 10px;">
                        <div style="margin: 5px; padding-left: 10px;">
                            <v-row dense>
                                <v-col cols="24" md="8">
                                    <b>Selected Agency:</b>
                                    {{ existingApp.caseManagementAgencyName }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="24" md="4">
                                    <v-btn v-if="cmAgencyDocument && cmAgencyDocument.documentId && cmAgencyDocument.documentId > 0"
                                           color="primary"
                                           text
                                           @click="downloadFile(cmAgencyDocument.contentBase64, cmAgencyDocument.filename, 'application/pdf')">
                                        <v-icon left>mdi-download</v-icon>
                                        {{ cmAgencyDocument.filename }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-card>
                <div v-if="hasNoApplication">
                    You have not yet submitted an application. Please go to the <router-link :to="{ name: 'application' }">Participant Application</router-link>  to complete an application.
                </div>
            </v-container>
        </v-form>
    </template>

<script setup lang="ts">
    import { ref, onMounted } from 'vue';
    import { useAuth0 } from '@/Services/Auth0/auth0-plugin';
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    //import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
    //import router from '@/Router/router'
    import { IParticipantApplication } from '@/Models/IParticipantApplication';
    import { IUser } from '@/Models/IUser'
    import { ParticipantApplicationService } from '@/Services/participant-application-service';
    import { UserService } from '@/Services/user-service';
    import { IPerson } from '../Models/IPerson';
    import { IPersonAddress } from '../Models/IPersonAddress';
    import { IPersonEmail } from '../Models/IPersonEmail';
    import { IPersonPhone } from '../Models/IPersonPhone';
    import { PersonService } from '@/Services/person-service';
    import { PersonAddressService } from '@/Services/person-address-service';
    import { PersonEmailService } from '@/Services/person-email-service';
    import { PersonPhoneService } from '@/Services/person-phone-service';
    import { PersonEmergencyContactService } from '@/Services/person-emergency-contact-service';
    import { IPersonEmergencyContact } from '../Models/IPersonEmergencyContact';
    import { IParticipantApplicationDocument } from '../Models/IParticipantApplicationDocument';
    import { IDocument } from '../Models/IDocument';
    import { ParticipantApplicationDocumentService } from '@/Services/participant-application-document-service';
    import { DocumentService } from '@/Services/document-service';

    const auth0: Auth0 | null = useAuth0();
    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };
    const loadingData = ref(true)

    let statusPending = ref(true);
    let statusDeclined = ref(false);
    let statusAccepted = ref(false);
    let statusMoreInfo = ref(false);
    
    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false
    let hasNoApplication = ref(true)
    let auth0UserId = ref()
    let user = ref<IUser | null>(null);
    let auth0User = ref()
    let existingApp = ref<IParticipantApplication | null>(null)
    let person = ref<IPerson | null>(null)
    let personAddresses = ref<IPersonAddress[] | null>(null)
    let personEmail = ref<IPersonEmail | null>(null)
    let personPhone = ref<IPersonPhone | null>(null)
    let personEmergencyContact = ref<IPersonEmergencyContact | null>(null)
    let participantPortalUserId = ref();
    let participantApplicationCmAgencyDocument = ref<IParticipantApplicationDocument | null>(null)
    let cmAgencyDocument = ref<IDocument | null>(null)
    
    onMounted(async () => {
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                auth0User.value = auth0 ? auth0.user.value : null;
                console.log('Application Status Page is auth0 authenticated: ' + isAuthenticated);
                if (auth0User.value) {
                    auth0UserId.value = auth0User.value.sub; // Access Auth0 user ID
                    //console.log('Auth0 User ID: ' + auth0UserId.value);
                    const r = await UserService.getByAuth0Id(auth0UserId.value);
                    user.value = r;
                    participantPortalUserId.value = user.value.participantPortalUserId;

                    //check if they have an application already
                    const appResult = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = appResult;

                    //console.log("existing app:" + JSON.stringify(existingApp.value, null, 2));
                    if (existingApp.value != null && existingApp.value.participantPortalUserId == participantPortalUserId.value) {
                        //don't let them submit again.
                        hasNoApplication.value = false;
                        //console.log('Application: ' + JSON.stringify(existingApp));
                        switch (existingApp.value.applicationResultId) {
                            case 1:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = true;
                                statusMoreInfo.value = false;
                                break;
                            case 2:
                                statusPending.value = false;
                                statusDeclined.value = true;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                break;
                            case 3:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = true;
                                break;
                            default:
                                statusPending.value = true;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                break;
                        }

                        const personResult = await PersonService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        person.value = personResult;
                        //console.log("Person: " + JSON.stringify(person));
                        const personAddressResult = await PersonAddressService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personAddresses.value = personAddressResult;
                        const personEmailResult = await PersonEmailService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmail.value = personEmailResult;
                        const personPhoneResult = await PersonPhoneService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personPhone.value = personPhoneResult;
                        const personEmergencyContactResult = await PersonEmergencyContactService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmergencyContact.value = personEmergencyContactResult;
                        const participantApplicationDocumentResult = await ParticipantApplicationDocumentService.getByParticipantApplicationId(existingApp.value.participantApplicationId, auth0UserId.value);
                        participantApplicationCmAgencyDocument.value = participantApplicationDocumentResult;
                        console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
                        if (participantApplicationCmAgencyDocument.value.documentId > 0) {
                            const cmAgencyDocumentResult = await DocumentService.getByDocumentId(participantApplicationCmAgencyDocument.value.documentId, existingApp.value.personId, auth0UserId.value);
                            cmAgencyDocument.value = cmAgencyDocumentResult;
                            console.log('document id: ' + cmAgencyDocument.value.documentId);
                            console.log('filename: ' + cmAgencyDocument.value.filename);
                        }

                    } else {
                        hasNoApplication.value = true;
                    }
                    console.log('hasNoApplication: ' + hasNoApplication.value);
                }
            }
        } catch (e) {
            //console.log('Not Authenticated.');
            const errorObj = e as Error;
            console.error('Authentication Error: ' + errorObj.message);
        } finally {
            loadingData.value = false;
        }
    });
</script>

<style>
</style>